import React from 'react';
import { getGrade, gradeLabelKo } from '../utils/trustSpeedGrades';

// 신뢰속도 (Trust Speed) 뱃지 — 당근마켓 매너온도(°C) 대체 (Wave TS-1.e).
// 5단계 grade 이모지 + 라벨 pill. 속도(km/h) 옵션 노출.
//
// props:
//   grade: 'IDLE'|'CRUISE'|'RAPID'|'BLAZE'|'LIGHTNING'
//   speed: number (옵션 — 표시 시 'NN km/h')
//   label: string (옵션 — i18n 라벨 주입. 미전달 시 한글 기본)
//   size: 'sm'|'md'|'lg' (기본 sm)
function TrustSpeedBadge(props) {
  var grade = props.grade || 'IDLE';
  var g = getGrade(grade);
  var size = props.size || 'sm';
  var label = props.label || gradeLabelKo(grade);
  var fontSize = size === 'lg' ? 13 : size === 'md' ? 12 : 11;
  var padY = size === 'lg' ? 4 : 3;
  var padX = size === 'lg' ? 10 : 8;
  var color = g.color;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: padY + 'px ' + padX + 'px', borderRadius: 9999, background: color + '22', border: '1px solid ' + color + '55', color: color, fontSize: fontSize, fontWeight: 700, whiteSpace: 'nowrap', lineHeight: 1 }}>
      <span style={{ fontSize: fontSize + 1 }}>{g.emoji}</span>
      <span>{label}</span>
      {props.speed != null && (
        <span style={{ fontVariantNumeric: 'tabular-nums', opacity: 0.85 }}>
          {Math.round(Number(props.speed))} km/h
        </span>
      )}
    </span>
  );
}

export default TrustSpeedBadge;
